/* tslint:disable */
/* eslint-disable */
/**
 * API Docs
 * The API description
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { GetJobResponse } from '../model';
// @ts-ignore
import { GetJobsResponse } from '../model';
// @ts-ignore
import { PostJobResponse } from '../model';
// @ts-ignore
import { SearchJobsResponse } from '../model';
/**
 * JobsApi - axios parameter creator
 * @export
 */
export const JobsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {Array<any>} [files] 
         * @param {string} [customerId] 
         * @param {string} [locationId] 
         * @param {string} [jobName] 
         * @param {string} [maintenanceDate] 
         * @param {Array<string>} [notes] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addJob: async (files?: Array<any>, customerId?: string, locationId?: string, jobName?: string, maintenanceDate?: string, notes?: Array<string>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/jobs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            if (files) {
                files.forEach((element) => {
                    localVarFormParams.append('files', element as any);
                })
            }

    
            if (customerId !== undefined) { 
                localVarFormParams.append('customerId', customerId as any);
            }
    
            if (locationId !== undefined) { 
                localVarFormParams.append('locationId', locationId as any);
            }
    
            if (jobName !== undefined) { 
                localVarFormParams.append('jobName', jobName as any);
            }
    
            if (maintenanceDate !== undefined) { 
                localVarFormParams.append('maintenanceDate', maintenanceDate as any);
            }
                if (notes) {
                localVarFormParams.append('notes', notes.join(COLLECTION_FORMATS.csv));
            }

    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteJob: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteJob', 'id', id)
            const localVarPath = `/api/jobs/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {string} fileName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadJobAttachFile: async (id: string, fileName: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('downloadJobAttachFile', 'id', id)
            // verify required parameter 'fileName' is not null or undefined
            assertParamExists('downloadJobAttachFile', 'fileName', fileName)
            const localVarPath = `/api/jobs/download/{id}/{fileName}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"fileName"}}`, encodeURIComponent(String(fileName)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        finishJob: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('finishJob', 'id', id)
            const localVarPath = `/api/jobs/{id}/finish-job`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllJob: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/jobs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getJobById: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getJobById', 'id', id)
            const localVarPath = `/api/jobs/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {Array<any>} [files] 
         * @param {string} [customerId] 
         * @param {string} [locationId] 
         * @param {string} [jobName] 
         * @param {string} [maintenanceDate] 
         * @param {Array<string>} [notes] 
         * @param {boolean} [removeFile] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putJob: async (id: string, files?: Array<any>, customerId?: string, locationId?: string, jobName?: string, maintenanceDate?: string, notes?: Array<string>, removeFile?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('putJob', 'id', id)
            const localVarPath = `/api/jobs/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            if (files) {
                files.forEach((element) => {
                    localVarFormParams.append('files', element as any);
                })
            }

    
            if (customerId !== undefined) { 
                localVarFormParams.append('customerId', customerId as any);
            }
    
            if (locationId !== undefined) { 
                localVarFormParams.append('locationId', locationId as any);
            }
    
            if (jobName !== undefined) { 
                localVarFormParams.append('jobName', jobName as any);
            }
    
            if (maintenanceDate !== undefined) { 
                localVarFormParams.append('maintenanceDate', maintenanceDate as any);
            }
                if (notes) {
                localVarFormParams.append('notes', notes.join(COLLECTION_FORMATS.csv));
            }

    
            if (removeFile !== undefined) { 
                localVarFormParams.append('removeFile', removeFile as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} keySearch 
         * @param {string} status 
         * @param {number} limit 
         * @param {number} page 
         * @param {string} orderBy 
         * @param {string} orderDesc 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchJobs: async (keySearch: string, status: string, limit: number, page: number, orderBy: string, orderDesc: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'keySearch' is not null or undefined
            assertParamExists('searchJobs', 'keySearch', keySearch)
            // verify required parameter 'status' is not null or undefined
            assertParamExists('searchJobs', 'status', status)
            // verify required parameter 'limit' is not null or undefined
            assertParamExists('searchJobs', 'limit', limit)
            // verify required parameter 'page' is not null or undefined
            assertParamExists('searchJobs', 'page', page)
            // verify required parameter 'orderBy' is not null or undefined
            assertParamExists('searchJobs', 'orderBy', orderBy)
            // verify required parameter 'orderDesc' is not null or undefined
            assertParamExists('searchJobs', 'orderDesc', orderDesc)
            const localVarPath = `/api/jobs/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (keySearch !== undefined) {
                localVarQueryParameter['keySearch'] = keySearch;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (orderBy !== undefined) {
                localVarQueryParameter['orderBy'] = orderBy;
            }

            if (orderDesc !== undefined) {
                localVarQueryParameter['orderDesc'] = orderDesc;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * JobsApi - functional programming interface
 * @export
 */
export const JobsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = JobsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {Array<any>} [files] 
         * @param {string} [customerId] 
         * @param {string} [locationId] 
         * @param {string} [jobName] 
         * @param {string} [maintenanceDate] 
         * @param {Array<string>} [notes] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addJob(files?: Array<any>, customerId?: string, locationId?: string, jobName?: string, maintenanceDate?: string, notes?: Array<string>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PostJobResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addJob(files, customerId, locationId, jobName, maintenanceDate, notes, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteJob(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteJob(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {string} fileName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadJobAttachFile(id: string, fileName: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadJobAttachFile(id, fileName, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async finishJob(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.finishJob(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllJob(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetJobsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllJob(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getJobById(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetJobResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getJobById(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {Array<any>} [files] 
         * @param {string} [customerId] 
         * @param {string} [locationId] 
         * @param {string} [jobName] 
         * @param {string} [maintenanceDate] 
         * @param {Array<string>} [notes] 
         * @param {boolean} [removeFile] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async putJob(id: string, files?: Array<any>, customerId?: string, locationId?: string, jobName?: string, maintenanceDate?: string, notes?: Array<string>, removeFile?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PostJobResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.putJob(id, files, customerId, locationId, jobName, maintenanceDate, notes, removeFile, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} keySearch 
         * @param {string} status 
         * @param {number} limit 
         * @param {number} page 
         * @param {string} orderBy 
         * @param {string} orderDesc 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchJobs(keySearch: string, status: string, limit: number, page: number, orderBy: string, orderDesc: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SearchJobsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchJobs(keySearch, status, limit, page, orderBy, orderDesc, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * JobsApi - factory interface
 * @export
 */
export const JobsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = JobsApiFp(configuration)
    return {
        /**
         * 
         * @param {Array<any>} [files] 
         * @param {string} [customerId] 
         * @param {string} [locationId] 
         * @param {string} [jobName] 
         * @param {string} [maintenanceDate] 
         * @param {Array<string>} [notes] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addJob(files?: Array<any>, customerId?: string, locationId?: string, jobName?: string, maintenanceDate?: string, notes?: Array<string>, options?: any): AxiosPromise<PostJobResponse> {
            return localVarFp.addJob(files, customerId, locationId, jobName, maintenanceDate, notes, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteJob(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.deleteJob(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {string} fileName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadJobAttachFile(id: string, fileName: string, options?: any): AxiosPromise<void> {
            return localVarFp.downloadJobAttachFile(id, fileName, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        finishJob(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.finishJob(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllJob(options?: any): AxiosPromise<GetJobsResponse> {
            return localVarFp.getAllJob(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getJobById(id: string, options?: any): AxiosPromise<GetJobResponse> {
            return localVarFp.getJobById(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {Array<any>} [files] 
         * @param {string} [customerId] 
         * @param {string} [locationId] 
         * @param {string} [jobName] 
         * @param {string} [maintenanceDate] 
         * @param {Array<string>} [notes] 
         * @param {boolean} [removeFile] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putJob(id: string, files?: Array<any>, customerId?: string, locationId?: string, jobName?: string, maintenanceDate?: string, notes?: Array<string>, removeFile?: boolean, options?: any): AxiosPromise<PostJobResponse> {
            return localVarFp.putJob(id, files, customerId, locationId, jobName, maintenanceDate, notes, removeFile, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} keySearch 
         * @param {string} status 
         * @param {number} limit 
         * @param {number} page 
         * @param {string} orderBy 
         * @param {string} orderDesc 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchJobs(keySearch: string, status: string, limit: number, page: number, orderBy: string, orderDesc: string, options?: any): AxiosPromise<SearchJobsResponse> {
            return localVarFp.searchJobs(keySearch, status, limit, page, orderBy, orderDesc, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for addJob operation in JobsApi.
 * @export
 * @interface JobsApiAddJobRequest
 */
export interface JobsApiAddJobRequest {
    /**
     * 
     * @type {Array<any>}
     * @memberof JobsApiAddJob
     */
    readonly files?: Array<any>

    /**
     * 
     * @type {string}
     * @memberof JobsApiAddJob
     */
    readonly customerId?: string

    /**
     * 
     * @type {string}
     * @memberof JobsApiAddJob
     */
    readonly locationId?: string

    /**
     * 
     * @type {string}
     * @memberof JobsApiAddJob
     */
    readonly jobName?: string

    /**
     * 
     * @type {string}
     * @memberof JobsApiAddJob
     */
    readonly maintenanceDate?: string

    /**
     * 
     * @type {Array<string>}
     * @memberof JobsApiAddJob
     */
    readonly notes?: Array<string>
}

/**
 * Request parameters for deleteJob operation in JobsApi.
 * @export
 * @interface JobsApiDeleteJobRequest
 */
export interface JobsApiDeleteJobRequest {
    /**
     * 
     * @type {string}
     * @memberof JobsApiDeleteJob
     */
    readonly id: string
}

/**
 * Request parameters for downloadJobAttachFile operation in JobsApi.
 * @export
 * @interface JobsApiDownloadJobAttachFileRequest
 */
export interface JobsApiDownloadJobAttachFileRequest {
    /**
     * 
     * @type {string}
     * @memberof JobsApiDownloadJobAttachFile
     */
    readonly id: string

    /**
     * 
     * @type {string}
     * @memberof JobsApiDownloadJobAttachFile
     */
    readonly fileName: string
}

/**
 * Request parameters for finishJob operation in JobsApi.
 * @export
 * @interface JobsApiFinishJobRequest
 */
export interface JobsApiFinishJobRequest {
    /**
     * 
     * @type {string}
     * @memberof JobsApiFinishJob
     */
    readonly id: string
}

/**
 * Request parameters for getJobById operation in JobsApi.
 * @export
 * @interface JobsApiGetJobByIdRequest
 */
export interface JobsApiGetJobByIdRequest {
    /**
     * 
     * @type {string}
     * @memberof JobsApiGetJobById
     */
    readonly id: string
}

/**
 * Request parameters for putJob operation in JobsApi.
 * @export
 * @interface JobsApiPutJobRequest
 */
export interface JobsApiPutJobRequest {
    /**
     * 
     * @type {string}
     * @memberof JobsApiPutJob
     */
    readonly id: string

    /**
     * 
     * @type {Array<any>}
     * @memberof JobsApiPutJob
     */
    readonly files?: Array<any>

    /**
     * 
     * @type {string}
     * @memberof JobsApiPutJob
     */
    readonly customerId?: string

    /**
     * 
     * @type {string}
     * @memberof JobsApiPutJob
     */
    readonly locationId?: string

    /**
     * 
     * @type {string}
     * @memberof JobsApiPutJob
     */
    readonly jobName?: string

    /**
     * 
     * @type {string}
     * @memberof JobsApiPutJob
     */
    readonly maintenanceDate?: string

    /**
     * 
     * @type {Array<string>}
     * @memberof JobsApiPutJob
     */
    readonly notes?: Array<string>

    /**
     * 
     * @type {boolean}
     * @memberof JobsApiPutJob
     */
    readonly removeFile?: boolean
}

/**
 * Request parameters for searchJobs operation in JobsApi.
 * @export
 * @interface JobsApiSearchJobsRequest
 */
export interface JobsApiSearchJobsRequest {
    /**
     * 
     * @type {string}
     * @memberof JobsApiSearchJobs
     */
    readonly keySearch: string

    /**
     * 
     * @type {string}
     * @memberof JobsApiSearchJobs
     */
    readonly status: string

    /**
     * 
     * @type {number}
     * @memberof JobsApiSearchJobs
     */
    readonly limit: number

    /**
     * 
     * @type {number}
     * @memberof JobsApiSearchJobs
     */
    readonly page: number

    /**
     * 
     * @type {string}
     * @memberof JobsApiSearchJobs
     */
    readonly orderBy: string

    /**
     * 
     * @type {string}
     * @memberof JobsApiSearchJobs
     */
    readonly orderDesc: string
}

/**
 * JobsApi - object-oriented interface
 * @export
 * @class JobsApi
 * @extends {BaseAPI}
 */
export class JobsApi extends BaseAPI {
    /**
     * 
     * @param {JobsApiAddJobRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JobsApi
     */
    public addJob(requestParameters: JobsApiAddJobRequest = {}, options?: AxiosRequestConfig) {
        return JobsApiFp(this.configuration).addJob(requestParameters.files, requestParameters.customerId, requestParameters.locationId, requestParameters.jobName, requestParameters.maintenanceDate, requestParameters.notes, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {JobsApiDeleteJobRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JobsApi
     */
    public deleteJob(requestParameters: JobsApiDeleteJobRequest, options?: AxiosRequestConfig) {
        return JobsApiFp(this.configuration).deleteJob(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {JobsApiDownloadJobAttachFileRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JobsApi
     */
    public downloadJobAttachFile(requestParameters: JobsApiDownloadJobAttachFileRequest, options?: AxiosRequestConfig) {
        return JobsApiFp(this.configuration).downloadJobAttachFile(requestParameters.id, requestParameters.fileName, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {JobsApiFinishJobRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JobsApi
     */
    public finishJob(requestParameters: JobsApiFinishJobRequest, options?: AxiosRequestConfig) {
        return JobsApiFp(this.configuration).finishJob(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JobsApi
     */
    public getAllJob(options?: AxiosRequestConfig) {
        return JobsApiFp(this.configuration).getAllJob(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {JobsApiGetJobByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JobsApi
     */
    public getJobById(requestParameters: JobsApiGetJobByIdRequest, options?: AxiosRequestConfig) {
        return JobsApiFp(this.configuration).getJobById(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {JobsApiPutJobRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JobsApi
     */
    public putJob(requestParameters: JobsApiPutJobRequest, options?: AxiosRequestConfig) {
        return JobsApiFp(this.configuration).putJob(requestParameters.id, requestParameters.files, requestParameters.customerId, requestParameters.locationId, requestParameters.jobName, requestParameters.maintenanceDate, requestParameters.notes, requestParameters.removeFile, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {JobsApiSearchJobsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JobsApi
     */
    public searchJobs(requestParameters: JobsApiSearchJobsRequest, options?: AxiosRequestConfig) {
        return JobsApiFp(this.configuration).searchJobs(requestParameters.keySearch, requestParameters.status, requestParameters.limit, requestParameters.page, requestParameters.orderBy, requestParameters.orderDesc, options).then((request) => request(this.axios, this.basePath));
    }
}
